module.exports = __webpack_public_path__ + "img/food.4bbe88dc.jpg";